
const digest = 'b9ac30f5572140d6d46a674aea68fba33d7bb8981c5ae2d592283017c07003ee';
const classes = {"wrapper":"_wrapper_1n8sv_1","suffix":"_suffix_1n8sv_10","prefix":"_prefix_1n8sv_18","input":"_input_1n8sv_26","inputPrefix":"_inputPrefix_1n8sv_61"};
const css = `._wrapper_1n8sv_1 {
  position: relative;
  font-family: Rubik, "sans-serif";
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  width: 100%;
}
._wrapper_1n8sv_1 ._suffix_1n8sv_10 {
  color: #1665d8;
  font-weight: 400;
  font-size: 14px;
  position: absolute;
  z-index: 1;
  right: 35px;
}
._wrapper_1n8sv_1 ._prefix_1n8sv_18 {
  color: #1665d8;
  font-weight: 400;
  font-size: 14px;
  position: absolute;
  z-index: 1;
  left: 20px;
}
._wrapper_1n8sv_1 ._input_1n8sv_26 {
  width: -webkit-fill-available;
  border: 1px solid #e2e5ed;
  min-height: 55px;
  font-family: Rubik, sans-serif;
  font-size: 14px;
  font-weight: 400;
  border-right: 0;
  border-radius: 24.5px;
  box-shadow: inset 0 4px 0 0 rgba(226, 229, 237, 0.3);
  padding: 16px 20px;
  color: #000;
  background-color: #fff;
  flex: 1;
  max-width: 100%;
}
._wrapper_1n8sv_1 ._input_1n8sv_26:disabled {
  background-color: #f3f3f3;
  opacity: 1;
}
._wrapper_1n8sv_1 ._input_1n8sv_26:focus {
  box-shadow: 0 0 0 3px rgba(22, 101, 216, 0.15), inset 0 4px 0 0 rgba(226, 229, 237, 0.3);
  border-color: #1665d8;
  color: #000;
}
._wrapper_1n8sv_1 ._input_1n8sv_26[type=number]::-webkit-outer-spin-button, ._wrapper_1n8sv_1 ._input_1n8sv_26[type=number]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  display: none;
}
._wrapper_1n8sv_1 ._input_1n8sv_26[type=number] {
  -moz-appearance: textfield;
}
._wrapper_1n8sv_1 ._input_1n8sv_26 input {
  padding-right: 40px;
}
._wrapper_1n8sv_1 ._input_1n8sv_26._inputPrefix_1n8sv_61 {
  padding-left: 40px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  